<template>
    <div v-bind:data-app-name="newsroomEditTyp">
        <div id="app" class="c-newsroom-ch--default">
	    	<div data-css="c-form" class="c-form--default is-form newsroom-ch__form">
                <fieldset class="form__fieldset is-small">
                  <legend class="form__legend is-col-mobile-p-12">
                    <!-- categoryFilterText -->                
                    {{ text.categoryFilterText }}
                </legend>
                    <div class="form__col is-grid-col is-col-tablet-p-12">
                      <div class="form__radio">
                        <div class="form__radio-wrapper">
                          <ul class="form__radio-list">
                            <li class="form__radio-item">
                              <input  id='radio-0' name="radio" type="radio" value='all' v-model="selectedCategoryType" :checked="true" :required="true" class="form__radio-input" />
                              <label role="button" for='radio-0' class="form__radio-label">
                                  <!-- allText -->
                                {{ text.allText }}
                              </label>
                            </li>
                           <li class="form__radio-item" v-for="onecategorytype in categoryTypes">
                              <input  v-bind:id="'radio-' + onecategorytype.id" name="radio" type="radio" v-bind:value="onecategorytype.value" :required="true" v-model="selectedCategoryType" class="form__radio-input" />
                              <label role="button" v-bind:for="'radio-' + onecategorytype.id" class="form__radio-label">
                                 {{ onecategorytype.label }}
                              </label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                </fieldset>
                <fieldset class="form__fieldset is-small">
                    <div class="form__col is-grid-col is-col-tablet-p-7">
                      <div class="form__input">
                          <div class="form__label-wrapper">
                              <label for="text1" class="form__input-label">
                                  <strong>
                                    <!-- searchListText -->
                                    {{ text.searchListText }}
                                </strong>
                              </label>
                          </div>
                          <div class="form__input-wrapper">
                              <input id="text1" name="text1" type="text" class="form__input-text" v-model="search" :placeholder="text.searchInputPlaceholderText" />
                          </div>
                      </div>
                    </div>
                </fieldset>
           </div>
	       <div class="newsroom-ch__form-area">
              <div class="form__select-wrapper" style="float:right;">
                <select id="sort_news" name="sort_news" :required="true" v-model="sort" :placeholder="text.sortByText" class="newsroom-ch__form-select">
                    <option :selected="true" value="">
                        <!-- chooseSortingTypeText -->
                        {{ text.chooseSortingTypeText }}:
                    </option>
                    <option v-for="optionItem in options" v-bind:value="optionItem.value">
                        {{text.sortByText}} {{ optionItem.label }}</option>
                </select>
              </div>
	      </div>
	      <span v-if="!filteredItems.length">
          <!-- noSearchResultsText -->
          {{ text.noSearchResultsText }}
        </span>
            <ul class="c-filterable-list--filterable-list" data-css="c-filterable-list">
              <li class="filterable-list__list-item" tabindex="-1" v-bind:id="'item' + listitem.id" v-bind:data-js-module="listitem.link.overlay" v-for="listitem in filteredItems">
                <div class="filterable-list__list-item-image" v-bind:class="'is-' + listitem.category">
                <template v-if="listitem.image && listitem.image.content.fallbackSrc != ''">
                    <picture class="c-picture--default" data-css="c-picture">
                        <!--[if IE 9]><audio><![endif]-->
                          <template  v-for="imgItem in listitem.image.content.items">
                            <source v-bind:data-srcset="imgItem.srcset" v-bind:sizes="imgItem.sizes" v-bind:media="imgItem.media" v-bind:type="imgItem.type">
                          </template>
                        <!--[if IE 9]></audio><![endif]-->
                          <img class="picture__image" v-bind:src="listitem.image.content.fallbackSrc" v-bind:alt="listitem.image.content.alt" v-bind:title="listitem.image.content.title" data-sizes="auto">
                    </picture>
                </template>
                <template v-else>
                    	<picture class="c-picture--default" data-css="c-picture">
                          	<img class="picture__image" :src="fallbackImgPath" alt="LMU-Logo" data-sizes="auto">
                    	</picture>
                </template>
                    <template v-if="listitem.category && listitem.category == 'events'">
                      <div class="filterable-list__list-item-dates">
                        <template v-for="(onedateDetail, index) in listitem.dateDetails">
                          <div v-if="index == listitem.dateDetails.length - 1 && index !== 0" class="filterable-list__list-item-date is-connector">
                            <abbr v-bind:aria-label="text.till" :title="text.title" class="filterable-list__list-item-date-connect">&mdash;</abbr>
                          </div>    
                          <div class="filterable-list__list-item-date">
                              <span v-bind:aria-label="onedateDetail.dateDay" class="filterable-list__list-item-date-day">{{onedateDetail.dateDay}}</span>
                              <abbr v-bind:aria-label="onedateDetail.dateMonthFull" v-bind:title="onedateDetail.dateMonthFull" class="filterable-list__list-item-date-month">{{onedateDetail.dateMonthAbbr}}</abbr>
                          </div>
                        </template>
                      </div>
                    </template>
                </div>
                <div class="filterable-list__list-item-text-wrapper" v-bind:class="'is-' + listitem.category">
                    <em class="filterable-list__list-item-meta">
                    <span class="filterable-list__list-item-meta-category">{{ listitem.categoryHeadline }}{{' '}}</span> 
                    <span v-if="listitem.date != '' && listitem.category && listitem.category != 'events'" class="filterable-list__list-item-meta-date">{{ listitem.date }}{{' '}}</span>
                    <span v-if="listitem.dateDetails && listitem.dateDetails != '' && listitem.category && listitem.category == 'events'" class="filterable-list__list-item-meta-date">
                    	<template v-for="(onedateDetail, index) in listitem.dateDetails">
                    		<template v-if="index == listitem.dateDetails.length - 1 && index !== 0">&nbsp;-&nbsp;</template>
                    		{{onedateDetail.date}}{{' '}}
                    	</template>
                    </span>
                    <span v-if="listitem.categoryAddition" class="filterable-list__list-item-meta-addition">{{listitem.categoryAddition}}</span>
                    <span v-if="listitem.editorialType" style="background-color:#999999;color:#FFFFFF;padding:0px 4px 0px 4px;display:inline-block;">{{listitem.editorialType}}</span>{{ '' }}
                    <span v-if="listitem.translatedLangs" style="background-color:#999999;color:#FFFFFF;padding:0px 4px 0px 4px; display: inline-block;">{{listitem.translatedLangs}}</span>
                    </em>
                    <template v-if="listitem.link.overlay && listitem.link.overlay != '' && listitem.link.overlay == 'overlay-handler'">
	                   <a class="filterable-list__list-item-link" v-bind:class="'is-' + listitem.category" v-bind:href="listitem.link.href" aria-haspopup="true" aria-controls="overlay" aria-expanded="false" data-js-item="overlay-handler-cta" v-bind:data-content="listitem.link.dataContent">{{ listitem.link.text }}<span v-if="listitem.link.info" class="filterable-list__list-item-link-info">{{listitem.link.info}}</span></a>
	                </template>
	                <template v-else>
	                   <a class="filterable-list__list-item-link" v-bind:class="'is-' + listitem.category" v-bind:href="listitem.link.href">{{ listitem.link.text }}<span v-if="listitem.link.info" class="filterable-list__list-item-link-info">{{listitem.link.info}}</span></a>
	                </template>
                    <template v-if="listitem.topicLabel && listitem.topicLabel != ''">
                      <span class="filterable-list__list-item-topic-headline">{{listitem.topicLabel}}</span>
                      <ul v-if="listitem.topics"  class="filterable-list__list-item-topics">
                          <li v-for="topic in listitem.topics" class="filterable-list__list-item-topic-item">{{topic.text}}</li>
                      </ul>
                    </template>
                    <template v-if="listitem.time && listitem.time != '' && listitem.address && listitem.address != '' ">
                      <div class="filterable-list__list-item-event">
                        <time class="filterable-list__list-item-time">{{listitem.time}} {{listitem.timeUnit}}</time>
                        <address class="filterable-list__list-item-address">{{listitem.address}}</address>
                      </div>
                    </template>
                    <template v-if="listitem.infoline && listitem.infoline != ''">
                      <p class="filterable-list__list-item-description" v-html="listitem.infoline"></p>
                    </template>
                    <p class="filterable-list__list-item-description">{{ listitem.description }}</p>
                    <template v-if="listitem.videoInfo && listitem.videoInfo != ''">
                      <p class="filterable-list__list-item-info-video" v-html="listitem.videoInfo"></p>
                    </template>
                    <template v-if="listitem.deadline && listitem.deadline != ''">
                      <strong class="filterable-list__list-item-deadline">{{listitem.deadlineLabel}}{{listitem.deadline}}</strong>
                    </template>
                </div>
               	<template v-if="listitem.link.dataContent && listitem.link.dataContent != ''">
                	<a class="filterable-list__a11y-clickarea" v-bind:href="listitem.link.href" aria-hidden="true" tabindex="-1" aria-haspopup="true" aria-expanded="false" data-js-item="overlay-handler-cta" :data-content="listitem.link.dataContent"></a>
                </template>
                <template v-else>
                	<a class="filterable-list__a11y-clickarea" aria-hidden="true" tabindex="-1" v-bind:href="listitem.link.href"></a>
                </template>
        	</li>
    	</ul>
	    </div>
        <FetchError v-if="fetchError.hasError" :fetch-error="fetchError" />        
    </div>
</template>


<script>
import FetchError from './FetchError.vue';

export default {
    name: 'NewsroomCh_News',
    components: {
        FetchError,        
    },
    data() {
        return {
            newsroomEditTyp: this.rootData.newsroomEditTyp || '',
            items: [],
            fetchError: {
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            },
            selectedCategoryType: this.rootData.selectedCategoryType || "all",
            options: this.rootData.options || [],
            categoryTypes: this.rootData.categoryTypes || [],
            search: '',
            sort: this.rootData.sort || '',
            fetchUrl: this.rootData.fetchUrl,  
            text: this.rootData.text,
            fallbackImgPath: this.rootData.fallbackImgPath

        }
    },
    computed: {
        filteredItems() {
            const categoryType = this.selectedCategoryType;
            let filteredItems = '';
            const search = this.search;
            if (categoryType === "all") {
                filteredItems = this.items.filter(function (listitem) {
                    return listitem.link.text.toLowerCase().match(search.toLowerCase()) || listitem.date.match(search) || listitem.description.toLowerCase().match(search.toLowerCase());
                });
            } else {
                filteredItems = this.items.filter(function (listitem) {
                    return (listitem.categoryType === categoryType && (listitem.link.text.toLowerCase().match(search.toLowerCase()) || listitem.date.match(search) || listitem.description.toLowerCase().match(search.toLowerCase())));
                });
            }

            // Sortierung
            if (this.sort == 'title') {
                return _.orderBy(filteredItems, ['link.text', 'date_sort'])
            } else if (this.sort == 'date_sort') {
                return _.orderBy(filteredItems, ['date_sort', 'link.text'], ['desc'])
            }
            else {
                return filteredItems;
            }

        }
    },
    created: async function () {
        await this.fetchItems();
    },
    methods: {
        fetchItems: async function () {
            const response = await fetch(this.fetchUrl);
            if (response.ok) {
                const json = await response.json()
                this.items = json.items;
                this.categoryTypes = json.filter.categoryTypes;
            } else {
                this.fetchError.hasError = true;
                this.fetchError.errorCode = response.status;
                this.fetchError.statusText = response.statusText;
                this.fetchError.errorMessage = 'There is a error for fetching data';
            }
        }
    }
}


</script>